<div class="view-component">
    <div class="view-component-title">
        <span class="title">Preferências do Contrato</span>
    </div>
    <div class="content">
        <simple-datagrid entityName="Mktpcontractpref" [parentRow]="parentRow" [condition]="condition" nodata="true" [events]="eventsSubject.asObservable()"></simple-datagrid>
    </div>
</div> 